import script from "./ip-blocking-trend-chart.vue?vue&type=script&lang=ts&setup=true"
export * from "./ip-blocking-trend-chart.vue?vue&type=script&lang=ts&setup=true"

import "./ip-blocking-trend-chart.vue?vue&type=style&index=0&id=22e3f6aa&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22e3f6aa"]])

export default __exports__